module.exports = __webpack_public_path__ + "static/media/favicon.25281b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/favicon.png
// module id = 489
// module chunks = 0